// Custom Hooks - Using named exports to match the actual exports
export { useAuthorData } from './useAuthorData';
export { useBlogScroll } from './useBlogScroll';
export { useBlogSearch } from './useBlogSearch';
export { useDarkMode } from './useDarkMode';
export { useDeviceType } from './useDeviceType';
export { useFonts } from './useFonts';
export { useHydration } from './useHydration';
export { useModal } from './useModal';
export { useSmoothScroll } from './useSmoothScroll';
export { useTableOfContents } from './useTableOfContents';
export { default as usePageData } from './usePageData';
export { default as useBreadcrumbs } from './useBreadcrumbs';
export { useBookingForm } from './useBookingForm';
export { useCountryCodes } from './useCountryCodes';
export { useBookingFormData } from './useBookingFormData';
export { useBookingValidation } from './useBookingValidation';
export { useBookingSubmit } from './useBookingSubmit';
